/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 10:01:31 
 * @Last Modified by: jingyu.yang
 * @Last Modified time: 2021-12-17 11:27:27
 */
import { Message } from "element-ui"
export default (fn, name) => fn.then(data => {
  if (name) {
    if (name === "status") {
      if (data.status !== 0) {
        Message({
          message: data.message,
          type: "error"
        })
        return ["", data]
      }
    }
    if (name === "code") {
      if (data.code !== 200) {
        Message({
          message: data.message,
          type: "error"
        })
        return ["", data]
      }
    }
  }
  return [null, data]
}).catch(err => {
  if (name) {
    Message({
      message: "服务器异常",
      type: "error"
    })
  }
  return [err, {}]
})